module.exports = __webpack_public_path__ + "img/3-5.35d8cdc2.png";